























































































































































































import { Component, Vue } from 'vue-property-decorator';
import Webinar from '@/models/Webinar';
import { getWebinars } from '@/api/api';
import AuthModule from '@/store/AuthModule';
import { BACKEND_URL } from '@/helpers/constants';

@Component
export default class WebinarView extends Vue {
    demoItems: Webinar[] = [];
    loading: boolean = true;
    
    get totalWebinars(): number {
        return this.demoItems.length;
    }
    
    get recentWebinars(): number {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        return this.demoItems.filter(item => 
            new Date(item.created_at || '') > oneWeekAgo
        ).length;
    }
    
    get viewedWebinars(): number {
        return Math.floor(this.demoItems.length * 0.6);
    }

    get firstname() {
        return AuthModule.firstname;
    }

    get lastname() {
        return AuthModule.lastname;
    }

    get logo() {
        return AuthModule.logo;
    }

    get backendUrl() {
        return BACKEND_URL;
    }


    async created() {
        await this.loadDemoItems();
    }

    async loadDemoItems(): Promise<void> {
        try {
            this.loading = true;
            await AuthModule.getUser();
            const userId = AuthModule.userID;
            if (userId) {
                const { data } = await getWebinars(userId);
                this.demoItems = data;
            }
        } catch (error) {
            console.error('Error loading webinars:', error);
            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: 'Impossible de charger les formations'
            });
        } finally {
            this.loading = false;
        }
    }

    getPlatformIcon(link: string): string {
        if (link.includes('youtube.com') || link.includes('youtu.be')) return 'video_library';
        if (link.includes('drive.google.com')) return 'folder';
        if (link.includes('vimeo.com')) return 'videocam';
        if (link.includes('zoom.us')) return 'video_call';
        if (link.includes('teams.microsoft.com')) return 'group';
        if (link.includes('dropbox.com')) return 'cloud';
        if (link.includes('.pdf')) return 'picture_as_pdf';
        return 'link';
    }

    getPlatformClass(link: string): string {
        if (link.includes('youtube.com') || link.includes('youtu.be')) return 'youtube';
        if (link.includes('drive.google.com')) return 'google-drive';
        if (link.includes('vimeo.com')) return 'vimeo';
        if (link.includes('zoom.us')) return 'zoom';
        if (link.includes('teams.microsoft.com')) return 'teams';
        if (link.includes('dropbox.com')) return 'dropbox';
        if (link.includes('.pdf')) return 'pdf';
        return 'other';
    }

    getPlatformName(link: string): string {
        if (link.includes('youtube.com') || link.includes('youtu.be')) return 'YouTube';
        if (link.includes('drive.google.com')) return 'Google Drive';
        if (link.includes('vimeo.com')) return 'Vimeo';
        if (link.includes('zoom.us')) return 'Zoom';
        if (link.includes('teams.microsoft.com')) return 'Teams';
        if (link.includes('dropbox.com')) return 'Dropbox';
        if (link.includes('.pdf')) return 'PDF';
        return 'Lien externe';
    }

    getDescription(link: string): string {
        if (link.includes('youtube.com') || link.includes('youtu.be')) return 'Vidéo sur YouTube';
        if (link.includes('drive.google.com')) return 'Document ou présentation Google Drive';
        if (link.includes('vimeo.com')) return 'Vidéo sur Vimeo';
        if (link.includes('zoom.us')) return 'Webinaire en direct ou enregistré';
        if (link.includes('teams.microsoft.com')) return 'Réunion Microsoft Teams';
        if (link.includes('dropbox.com')) return 'Fichier partagé Dropbox';
        if (link.includes('.pdf')) return 'Document PDF';
        return 'Ressource externe';
    }

    formatDate(dateString: string | undefined): string {
        if (!dateString) return 'Date inconnue';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    }

    goToTrial(): void {
        this.$router.push({ name: 'Trial' });
    }

    openWebinar(link: string): void {
        window.open(link, '_blank', 'noopener,noreferrer');
    }

    async copyLink(link: string): Promise<void> {
        try {
            await navigator.clipboard.writeText(link);
            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Lien copié',
                text: 'Le lien a été copié dans le presse-papier'
            });
        } catch (error) {
            const $vs = (this as any).$vs;
            $vs.notify({
                color: 'warning',
                position: 'top-right',
                title: 'Erreur',
                text: 'Impossible de copier le lien'
            });
        }
    }
}
